module.exports = __webpack_public_path__ + "img/restore.2c0997b4.svg";